import { AUTH_USE_COOKIES } from '../../config/constants';

const ACCESS_KEY = 'APP_TOKEN';
const REFRESH_KEY = 'APP_REFRESH_TOKEN';

/** Modo Bearer legado (localStorage). Com cookies HttpOnly, sempre false. */
export const isBearerTokenStorageEnabled = (): boolean => !AUTH_USE_COOKIES;

export const setTokens = (accessToken: string, refreshToken?: string): void => {
  if (AUTH_USE_COOKIES) {
    clearTokens();
    return;
  }
  localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) {
    sessionStorage.setItem(REFRESH_KEY, refreshToken);
  }
};

export const getToken = (): string | null => {
  if (AUTH_USE_COOKIES) {
    return null;
  }
  return localStorage.getItem(ACCESS_KEY);
};

export const getRefreshToken = (): string | null => {
  if (AUTH_USE_COOKIES) {
    return null;
  }
  return sessionStorage.getItem(REFRESH_KEY);
};

export const removeToken = (): void => {
  localStorage.removeItem(ACCESS_KEY);
};

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
};

export const hasStoredAccessToken = (): boolean => {
  return isBearerTokenStorageEnabled() && Boolean(localStorage.getItem(ACCESS_KEY));
};

export const hasStoredRefreshToken = (): boolean => {
  return isBearerTokenStorageEnabled() && Boolean(sessionStorage.getItem(REFRESH_KEY));
};
